<template lang="pug">
    .contactpage.container.content
        form(@submit.prevent="sendContactForm")
            .columns
                .field.column
                    label.label(for="firstname") Vorname
                    .control.has-icons-right
                        input#firstname.input(type="text")
                        span.icon.is-small.is-right
                            i.fas.fa-user
                .field.column
                    label.label(for="lastname") Nachname
                    .control.has-icons-right
                        input#lastname.input(type="text")
                        span.icon.is-small.is-right
                            i.fas.fa-user
            .columns
                .field.column
                    label.label(for="email") E-Mail Adresse
                    .control.has-icons-right
                        input#email.input(type="email")
                        span.icon.is-small.is-right
                            i.fas.fa-envelope
                .field.column
                    label.label(for="phone") Telefon
                    .control.has-icons-right
                        input#phone.input(type="text")
                        span.icon.is-small.is-right
                            i.fas.fa-phone
            .field
                label.label(for="message") Ihre Nachricht
                .control
                    textarea.textarea
            .columns
                .field.column.is-8
                    .control
                        label.checkbox
                            input(type="checkbox")
                            |  Ich stimme den Datenschutzbestimmungen zu
                .field.column.is-4
                    .control
                        button.button.is-pulled-right.is-primary(type="submit") Absenden
</template>

<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex'
import store from '@/store';

export default {
    name: 'Contact',
    components: {
        Error,
    },
    props: {
        section: {
            type: Object
        }
    },
    computed: {
        to() {
            return this.section.contents[0].link
        },
        ...mapGetters({
            view: 'currentPage/view',
            error: 'error',
            cms: 'CMS'
        }),
    },
    methods: {
        sendContactForm(submitEvent){
            let formData = {
                "created_by_name": submitEvent.target.elements[0].value + ' ' + submitEvent.target.elements[1].value,
                "created_by_email": submitEvent.target.elements[2].value,
                "phone": submitEvent.target.elements[3].value,
                "message": submitEvent.target.elements[4].value,
                "cms_id": this.cms.id,
                "to": this.to
            }
            submitEvent.target.reset();
            store.dispatch('sendContactToApi', formData)
        }
    }
}

</script>

<style lang="sass" scoped>
    @import '~@/assets/sass/variables';

    button
        .is-primary
            background-color: $primary!important
</style>
